import { getRecipientName } from './getRecipientName';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';

/**
 * Gets the names of attendees to display.
 */
const getAttendeesNames = (item: CalendarItem, getRequiredAttendees: boolean): string[] => {
    const attendees = getRequiredAttendees ? item.RequiredAttendees : item.OptionalAttendees;
    if (attendees?.length) {
        return attendees.map(attendee => getRecipientName(attendee.Mailbox));
    }
    return null;
};

export default getAttendeesNames;
